// extracted by mini-css-extract-plugin
export default {"note":"Bankstamp_note__rWyhB"};